import { render, staticRenderFns } from "./UnmarkAsDeceased.vue?vue&type=template&id=fc4ebdb2"
import script from "./UnmarkAsDeceased.vue?vue&type=script&lang=js"
export * from "./UnmarkAsDeceased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports